import { singleton } from 'tsyringe';

@singleton()
export class GameTime {
	private _deltaTime: number = 0;
	private _elapsedTime: number = 0;
	private _lastFrameTime: number = 0;
	private _frameCount: number = 0;

	/** Time since last frame in seconds */
	get deltaTime(): number {
		return this._deltaTime;
	}

	/** Time since last frame in milliseconds */
	get deltaTimeMs(): number {
		return this._deltaTime * 1000;
	}

	/** Total elapsed time since game start in seconds */
	get elapsedTime(): number {
		return this._elapsedTime;
	}

	/** Total elapsed time since game start in milliseconds */
	get elapsedTimeMs(): number {
		return this._elapsedTime * 1000;
	}

	/** Total frame count since game start */
	get frameCount(): number {
		return this._frameCount;
	}

	/** Call this at the start of each frame */
	update(): void {
		const now = performance.now();

		if (this._lastFrameTime === 0) {
			this._lastFrameTime = now;
			return;
		}

		this._deltaTime = (now - this._lastFrameTime) / 1000;
		this._elapsedTime += this._deltaTime;
		this._lastFrameTime = now;
		this._frameCount++;
	}

	reset(): void {
		this._deltaTime = 0;
		this._elapsedTime = 0;
		this._lastFrameTime = 0;
		this._frameCount = 0;
	}
}
